import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";

export default class V1UserGet extends BaseOutgoingPayload {
  public readonly payload: V1UserGetPayload;

  constructor(userId: string) {
    super(OutgoingPayloadEvent.V1_USER_GET);
    this.payload = new V1UserGetPayload(userId);
  }
}

class V1UserGetPayload {
  public readonly user_id: string;

  constructor(user_id: string) {
    this.user_id = user_id;
  }
}
